import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ThemeProvider, theme, Modal, ModalTitle, Text, ModalContent, Stack, TextField, ModalActions, Button, RadioGroup, Radio, styled, palette, useUtility, Box, Checkbox } from '@hub-la/design-system';
import { ContainerProvider, container, useContainer } from '@hub-la/fe-container';
import { CssBaseline } from '@mui/material';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { QueryClient, QueryClientProvider, useMutation } from 'react-query';
import i18next from 'i18next';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useState } from 'react';
import { Auth } from '@hub-la/fe-core-auth';
import { injectable, inject } from 'inversify';
import { Analytics, AnalyticsEvent } from '@hub-la/fe-core-analytics';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import CategoryIcon from '@mui/icons-material/Category';
import LocalMallOutlined from '@mui/icons-material/LocalMallOutlined';
import { useHistory } from 'react-router-dom';
import ArrowForwardOutlined from '@mui/icons-material/ArrowForwardOutlined';

const pt = {
  errors: {
    accountUserNotFound: 'O usuário não foi encontrado. É necessario que o usuário tenha uma conta na Hubla.',
    emailInvalid: 'E-mail inválido',
    emailRequired: 'E-mail é obrigatório',
    permissionsRequired: 'Permissões são obrigatórias'
  },
  selectUserLoginNavigationTarget: {
    title: 'Escolha como acessar',
    creatorNavigationTarget: {
      title: 'Acessar como produtor',
      subtitle: 'Para fazer a gestão dos produtos que você vende'
    },
    userNavigationTarget: {
      title: 'Acessar minhas compras',
      subtitle: 'Para acessar um produto que comprou'
    },
    checkboxDontAskAgain: 'Não me perguntar novamente'
  }
};

const i18n = i18next.createInstance({
  lng: 'pt',
  fallbackLng: 'pt',
  debug: false,
  react: {
    useSuspense: false
  },
  resources: {
    pt: {
      translation: pt
    }
  },
  interpolation: {
    escapeValue: false
  }
}, error => {
  if (error) return console.log(error);
});

const queryClient = new QueryClient();
const SigninProvider = ({
  children
}) => {
  return jsx(ContainerProvider, Object.assign({
    container: container
  }, {
    children: jsxs(ThemeProvider, Object.assign({
      theme: theme.light
    }, {
      children: [jsx(CssBaseline, {}), jsx(I18nextProvider, Object.assign({
        i18n: i18n
      }, {
        children: jsx(QueryClientProvider, Object.assign({
          client: queryClient
        }, {
          children: children
        }))
      }))]
    }))
  }));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

let SignInByEmail = class SignInByEmail {
  constructor(auth) {
    this.auth = auth;
  }
  execute(input) {
    return __awaiter(this, void 0, void 0, function* () {
      this.auth.signInWithPassword(input.email, input.password);
    });
  }
};
SignInByEmail = __decorate([injectable(), __param(0, inject(Auth)), __metadata("design:paramtypes", [Auth])], SignInByEmail);

const useSignInByEmail = () => {
  const container = useContainer();
  const execute = input => {
    new SignInByEmail(container.get(Auth)).execute(input);
  };
  return {
    execute
  };
};

const SignIn = () => {
  const {
    execute
  } = useSignInByEmail();
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    email: '',
    password: ''
  });
  const handleChange = event => {
    const name = event.target.name;
    const value = event.target.value;
    setValues(Object.assign(Object.assign({}, values), {
      [name]: value
    }));
  };
  return jsxs(Fragment, {
    children: [jsx(Modal, Object.assign({
      open: isOpen,
      close: () => setIsOpen(false)
    }, {
      children: jsxs(Fragment, {
        children: [jsx(ModalTitle, {
          children: jsx(Text, Object.assign({
            variant: "h3"
          }, {
            children: "Sign in"
          }))
        }), jsx(ModalContent, {
          children: jsxs(Stack, Object.assign({
            flexDirection: "column"
          }, {
            children: [jsx(TextField, {
              size: "small",
              marginBottom: 6,
              label: "Email*",
              value: values.email,
              onChange: handleChange,
              name: "email"
            }), jsx(TextField, {
              size: "small",
              label: "Password*",
              value: values.password,
              onChange: handleChange,
              name: "password",
              type: "password"
            })]
          }))
        }), jsx(ModalActions, Object.assign({
          align: "center"
        }, {
          children: jsx(Button, Object.assign({
            variant: "filled",
            hierarchy: "primary",
            fullWidth: true,
            onClick: () => execute(values)
          }, {
            children: "Continue"
          }))
        }))]
      })
    })), jsx(Button, Object.assign({
      variant: "filled",
      hierarchy: "primary",
      onClick: () => setIsOpen(true)
    }, {
      children: "Sign in"
    }))]
  });
};

var UserType;
(function (UserType) {
  UserType["CREATOR"] = "creator";
  UserType["BUYER"] = "buyer";
})(UserType || (UserType = {}));

var QueryKey;
(function (QueryKey) {
  QueryKey["putUserLoginPreferences"] = "putUserLoginPreferences";
})(QueryKey || (QueryKey = {}));

class AccountUserNotFound extends Error {
  constructor() {
    super();
    this.message = 'errors.accountUserNotFound';
  }
}

class GeneralError extends Error {
  constructor() {
    super();
    this.message = 'errors.general';
  }
}

var _a, _b;
const Envs = {
  BFF_WEB_URL: (_b = (_a = process.env['NEXT_PUBLIC_HUB_API']) !== null && _a !== void 0 ? _a : process.env['REACT_APP_HUB_API']) !== null && _b !== void 0 ? _b : process.env['NX_BFF_WEB_URL']
};

var ErrorCode;
(function (ErrorCode) {
  ErrorCode["ACCOUNT_USER_NOT_FOUND"] = "bff-web-account::user-not-found";
})(ErrorCode || (ErrorCode = {}));
let PutUserLoginPreferences = class PutUserLoginPreferences {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(input) {
    return __awaiter(this, void 0, void 0, function* () {
      const response = yield this.httpClient.request({
        method: HttpMethod.PUT,
        url: `${Envs.BFF_WEB_URL}/user/save-user-login-preferences`,
        body: this.makeBody(input)
      });
      if (response.statusCode === HttpStatusCode.CREATED) {
        return null;
      }
      switch (response.data.errorCode) {
        case ErrorCode.ACCOUNT_USER_NOT_FOUND:
          throw new AccountUserNotFound();
        default:
          throw new GeneralError();
      }
    });
  }
  makeBody({
    navigationTarget
  }) {
    return {
      navigationTarget
    };
  }
};
PutUserLoginPreferences = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], PutUserLoginPreferences);

const usePutUserLoginPreferences = () => {
  const container = useContainer();
  return useMutation([QueryKey.putUserLoginPreferences], input => new PutUserLoginPreferences(container.get(HttpClient)).execute(input), {
    retry: false
  });
};

const UserSettingsNavigationTarget = ({
  currentUser
}) => {
  const {
    t
  } = useTranslation();
  const {
    mutateAsync
  } = usePutUserLoginPreferences();
  const initialNavigationTarget = currentUser.loginPreferences && currentUser.loginPreferences.navigationTarget;
  const [selectedType, setSelectedType] = useState(initialNavigationTarget);
  const container = useContainer();
  const analytics = container.get(Analytics);
  const handleRadioChange = type => {
    switch (type) {
      case UserType.CREATOR:
        analytics.track(AnalyticsEvent.LOGIN_PREFERENCES.NAVIGATION_TARGET.CHANGE_TO_CREATOR_CLICKED);
        break;
      case UserType.BUYER:
        analytics.track(AnalyticsEvent.LOGIN_PREFERENCES.NAVIGATION_TARGET.CHANGE_TO_BUYER_CLICKED);
        break;
    }
    mutateAsync({
      navigationTarget: type
    });
    setSelectedType(type);
  };
  return jsxs(RadioGroup, Object.assign({
    row: true
  }, {
    children: [jsx(Radio, {
      label: t('UserForm.integrations.loginPreferences.navigationTarget.userType.creator'),
      labelPlacement: "end",
      checked: selectedType === UserType.CREATOR,
      onClick: () => handleRadioChange(UserType.CREATOR)
    }), jsx(Radio, {
      label: t('UserForm.integrations.loginPreferences.navigationTarget.userType.buyer'),
      labelPlacement: "end",
      checked: selectedType === UserType.BUYER,
      onClick: () => handleRadioChange(UserType.BUYER)
    })]
  }));
};

let _ = t => t,
  _t;
const UserLoginNavigationTargetWrapper = styled(Stack)(_t || (_t = _`
  cursor: pointer;
  &:hover {
    background: ${0};
    border-color: ${0};
  }
`), palette('surfaceAt2'), palette('primary'));
const UserLoginNavigationTarget = ({
  icon,
  title,
  subtitle,
  loading,
  onClick
}) => {
  const {
    palette
  } = useUtility();
  return jsxs(UserLoginNavigationTargetWrapper, Object.assign({
    direction: "row",
    alignItems: "center",
    border: 1.5,
    borderColor: palette('surfaceVariant'),
    p: 4,
    borderRadius: 4,
    justifyContent: "space-between",
    onClick: !loading ? onClick : undefined
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      gap: 4,
      alignItems: "center"
    }, {
      children: [jsx(Box, Object.assign({
        p: 2,
        bgcolor: palette('surfaceAt2'),
        borderRadius: 99,
        width: 40,
        height: 40
      }, {
        children: icon
      })), jsxs(Stack, {
        children: [jsx(Text, Object.assign({
          variant: "body1",
          color: "onSurface"
        }, {
          children: title
        })), jsx(Text, Object.assign({
          variant: "body2",
          color: "onSurfaceVariant"
        }, {
          children: subtitle
        }))]
      })]
    })), jsx(Button, Object.assign({
      iconOnly: true,
      variant: "text",
      size: "small",
      loading: loading
    }, {
      children: jsx(ArrowForwardOutlined, {})
    }))]
  }));
};

const SelectUserLoginNavigationTarget = () => {
  const [dontAskAgain, setDontAskAgain] = useState(false);
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    palette
  } = useUtility();
  const {
    mutateAsync
  } = usePutUserLoginPreferences();
  const container = useContainer();
  const analytics = container.get(Analytics);
  const handleNavigationTargetCreatorClick = () => {
    if (dontAskAgain) {
      mutateAsync({
        navigationTarget: UserType.CREATOR
      });
    }
    analytics.track(AnalyticsEvent.LOGIN_PREFERENCES.NAVIGATION_TARGET.CREATOR_CLICKED, {
      dontAskAgain
    });
    history.push('/dashboard');
  };
  const handleNavigationTargetBuyerClick = () => {
    if (dontAskAgain) {
      mutateAsync({
        navigationTarget: UserType.BUYER
      });
    }
    analytics.track(AnalyticsEvent.LOGIN_PREFERENCES.NAVIGATION_TARGET.BUYER_CLICKED, {
      dontAskAgain
    });
    history.push('/user_groups');
  };
  // Handler for checkbox changes
  const handleCheckboxChange = event => {
    setDontAskAgain(event.target.checked);
  };
  return jsxs(Box, Object.assign({
    maxWidth: 588,
    mx: "auto",
    mt: 8,
    mb: 8
  }, {
    children: [jsx(Text, Object.assign({
      mb: 3,
      variant: "h3"
    }, {
      children: t('selectUserLoginNavigationTarget.title')
    })), jsx(Stack, Object.assign({
      mt: 6
    }, {
      children: jsx(UserLoginNavigationTarget, {
        title: t('selectUserLoginNavigationTarget.userNavigationTarget.title'),
        subtitle: t('selectUserLoginNavigationTarget.userNavigationTarget.subtitle'),
        onClick: handleNavigationTargetBuyerClick,
        icon: jsx(LocalMallOutlined, {
          sx: {
            width: 24,
            height: 24,
            color: palette('onSurface')
          }
        })
      })
    })), jsx(Stack, Object.assign({
      mt: 3
    }, {
      children: jsx(UserLoginNavigationTarget, {
        title: t('selectUserLoginNavigationTarget.creatorNavigationTarget.title'),
        subtitle: t('selectUserLoginNavigationTarget.creatorNavigationTarget.subtitle'),
        onClick: handleNavigationTargetCreatorClick,
        icon: jsx(CategoryIcon, {
          sx: {
            width: 24,
            height: 24,
            color: palette('onSurface')
          }
        })
      })
    })), jsx(Stack, Object.assign({
      mt: 6,
      ml: 3
    }, {
      children: jsx(Checkbox, {
        checked: dontAskAgain,
        label: t('selectUserLoginNavigationTarget.checkboxDontAskAgain'),
        onChange: handleCheckboxChange
      }, 'dont-ask-again')
    }))]
  }));
};

export { SelectUserLoginNavigationTarget, SignIn, SigninProvider, UserSettingsNavigationTarget };
